let flickityInstance = null;

function toggleProductSlider() {
  const grid = document.querySelector('.product-grid-container');
  const isMobile = window.innerWidth <= 992;

  if (!grid) return;

  if (isMobile && !grid.classList.contains('flickity-enabled')) {
    flickityInstance = new Flickity(grid, {
      draggable: true,
      cellAlign: 'left',
      wrapAround: true,
      pageDots: false,
      contain: true,
      prevNextButtons: false
    });
  }

  if (!isMobile && grid.classList.contains('flickity-enabled') && flickityInstance) {
    flickityInstance.destroy();
    flickityInstance = null;
  }
}

document.addEventListener('DOMContentLoaded', toggleProductSlider);
window.addEventListener('resize', function () {
  toggleProductSlider();
});